<!--/*
 * Copyright (c) 2020 The Awareness Company. All rights reserved. 
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */ -->
<template>
  <div
    class="mapbox-map elevation-3"
    id="map"
    v-bind:style="{ 'min-height': $vuetify.breakpoint.mdAndDown? '500px !important': 'inherit'}"
  >
    <v-menu transition="slide-x-transition">
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          dark
          small
          color="purple darken-2"
          style="position: absolute; top: 10px; left: 10px; z-index: 99999;"
          v-bind="attrs"
          v-on="on"
        >Change Layer</v-btn>
      </template>
      <v-list class="pa-3" dense>
        <v-list-item @click="changeLayer('confirmed')">
          <v-list-item-title
            v-text="'Confirmed'"
            v-bind:class="[{ 'purple--text': activeLayer === 'confirmed' }]"
          ></v-list-item-title>
        </v-list-item>
        <!-- <v-list-item @click="changeLayer('recovered')">
          <v-list-item-title
            v-text="'Recovered'"
            v-bind:class="[{ 'purple--text': activeLayer === 'recovered' }]"
          ></v-list-item-title>
        </v-list-item> -->
        <v-list-item @click="changeLayer('deaths')">
          <v-list-item-title
            v-text="'Deaths'"
            v-bind:class="[{ 'purple--text': activeLayer === 'deaths' }]"
          ></v-list-item-title>
        </v-list-item>
        <!-- <v-list-item @click="changeLayer('active')">
          <v-list-item-title
            v-text="'Active'"
            v-bind:class="[{ 'purple--text': activeLayer === 'active' }]"
          ></v-list-item-title>
        </v-list-item> -->
        <v-list-item @click="changeLayer('tests')">
          <v-list-item-title
            v-text="'Testing'"
            v-bind:class="[{ 'purple--text': activeLayer === 'tests' }]"
          ></v-list-item-title>
        </v-list-item>
        <v-list-item @click="changeLayer('confirmedper100k')">
          <v-list-item-title
            v-text="'Confirmed Per 100k Pop.'"
            v-bind:class="[{ 'purple--text': activeLayer === 'confirmedper100k' }]"
          ></v-list-item-title>
        </v-list-item>
        <v-list-item @click="changeLayer('deathsper100k')">
          <v-list-item-title
            v-text="'Deaths Per 100k Pop.'"
            v-bind:class="[{ 'purple--text': activeLayer === 'deathsper100k' }]"
          ></v-list-item-title>
        </v-list-item>
        <v-list-item @click="changeLayer('bedsper100k')">
          <v-list-item-title
            v-text="'Hospital Beds Per 100k Pop.'"
            v-bind:class="[{ 'purple--text': activeLayer === 'bedsper100k' }]"
          ></v-list-item-title>
        </v-list-item>
        <v-list-item @click="changeLayer('facilities')" v-show="$vuetify.breakpoint.lgAndUp">
          <v-list-item-title
            v-text="'Public Health Facilities'"
            v-bind:class="[{ 'purple--text': activeLayer === 'facilities' }]"
          ></v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>

    <v-card v-show="showPlayback" style="position: absolute; bottom: 0; left:30px; right: 0px; z-index: 9999;" class="mb-1 transparent elevation-0">
      <v-slider
        dense
        dark
        hint="Playback cases over time"
        persistent-hint
        color="purple"
        track-color="purple"
        :max="maxTicks"
        v-model="tickValue"
      >
          <template v-slot:append>
            <span class="caption" style="min-width: 50px;">{{tickLabel}}</span>
          </template>
          <template v-slot:prepend>
            <v-btn
              x-small
              color="purple"
              dark
              depressed
              @click="togglePlay"
            >
              <v-icon small>
                {{ isPlaying ? 'mdi-pause' : 'mdi-play' }}
              </v-icon>
            </v-btn>
          </template>
      </v-slider>
    </v-card>
  </div>
</template>

<script>
import mapboxgl from "mapbox-gl";
import "mapbox-gl/dist/mapbox-gl.css";
import Papa from "papaparse";

export default {
  name: "Map",
  data: () => ({
    map: null,
    source: {},
    hospitalsource: {},
    mapLoaded: false,
    firstLoad: true,
    allData: [],
    allHospitalsData:[],
    countryDisplay: null,
    showLayers: false,
    activeLayer: "confirmed",
    allCountryBounds: [],
    currentDate: "",
    ticksLabels: [],
    tickValue: 0,
    tickLabel: "",
    maxTicks: 10,
    showPlayback: false,
    isPlaying: false,
    timer: null
  }),
  mounted() {
    // this vue component
    this.loadMap();
  },
  watch: {
    countryDisplay: function (val) {
      if (this.source.data) {

        this.loadData(this.allData, this.countryDisplay);

        //filter the hospitals
        if (this.countryDisplay && this.countryDisplay !== "") {
          //filter by country selected
          var copydata = this.allHospitalsData.filter(h => h.Country === this.countryDisplay)
          this.loadHospitalData(copydata)
        }
        else {
          if(this.countryDisplay === "") {
            //load all
            this.loadHospitalData(this.allHospitalsData)
          }
        }
      }
    },
    tickValue: function(val) {
      //get fomratted date
      this.tickLabel = this.$moment(this.ticksLabels[val], "YYYY-MM-DD").format("MMM YY")
      this.currDate = this.ticksLabels[val]

      //update the layers filter
      var filter =  ['all',
        ['==', ['get', 'date'], this.currDate]
      ]
      this.map.setFilter('cases-poly', filter)
      this.map.setFilter('cases-line', filter)
      this.map.setFilter('cases-count', filter)
    }
  },
  methods: {
    loadCases(lastDate, data, countryDisplay) {
      this.allData = data;
      this.countryDisplay = countryDisplay;
      this.currentDate = lastDate
    },
    loadData(data, countryDisplay) {
      var thisRef = this;

      //clear the data
      thisRef.source.data.features = [];

      //first loop through each country and concat the cases data to find the distinct monthly
      var allcases = []
      for (var i = 0; i < data.length; i++) {
        allcases = allcases.concat(data[i].cases)
      }

      //sort by date
      allcases = allcases.sort(function(a, b) {
        a = a.date;
        b = b.date;
        return a < b ? -1 : a > b ? 1 : 0;
      });

      //then get all the distinct week dates
      var dates = [];
      var binRes = "month"

      //less data for mobiles
      if(this.$vuetify.breakpoint.lgAndUp) {
        binRes = "week"
      }

      dates = Array.from(new Set(allcases.map(cas => this.$moment(cas.date, "YYYY-MM-DD").endOf(binRes).format("YYYY-MM-DD")))).map(date => {
        return date;
      });

      //remove the last date so we can add the last updated dates
      dates = dates.splice(0,dates.length -1)

      this.ticksLabels = JSON.parse(JSON.stringify(dates))
      this.ticksLabels.push(this.currentDate)
      this.maxTicks = this.ticksLabels.length -1
      this.tickValue = this.ticksLabels.length -1
      this.showPlayback = true


      //loop through each country and create the feature for the month dates
      for (var i = 0; i < data.length; i++) {

        //hospital beds per 100k population
        var beds = data[i].population.hospital_beds_100k * 1;

        //testing
        var tests = 0
        if(data[i].tests.length > 0) {
          tests = data[i].tests[data[i].tests.length -1]["Cumulative total"]*1 
        }

        //get the geometry from the country bounds
        var geom = thisRef.allCountryBounds.find(cb => cb.properties.name === data[i].Country_WHO)

         //first calculate the stats for each date
         for (var j = 0; j < dates.length; j++) {

           //find the matching case entry
           var cas = data[i].cases.find(c => c.date === dates[j])
           if(cas) {

             //calc the stats
             var lastConfirmed =
              cas.cumulative_cases;
              var lastRecovered =
                cas.cumulative_recovered;
              var lastDeaths =
                cas.cumulative_deaths;
              var lastActive = lastConfirmed - lastRecovered - lastDeaths;
              var lastUpdated = cas.date;

              //confirmed per 100k population
              var confirmedrate = lastConfirmed / data[i].population.population;
              var confirmedper100k = confirmedrate * 100000;
              confirmedper100k = parseFloat(confirmedper100k.toFixed(0));

              //confirmed per 100k population
              var deathsrate = lastDeaths / data[i].population.population;
              var rdeathsper100k = deathsrate * 100000;
              var deathsper100k = parseFloat(rdeathsper100k.toFixed(0));

              if (deathsper100k === 0) {
                deathsper100k = parseFloat(rdeathsper100k.toFixed(2));
              }              

              //create the feature
              var coords = [data[i].lng, data[i].lat];
              var props = {
                country: data[i].Country_WHO,
                confirmed: lastConfirmed,
                recovered: lastRecovered,
                deaths: lastDeaths,
                active: lastActive,
                date: lastUpdated,
                confirmedper100k: confirmedper100k,
                deathsper100k: deathsper100k,
                bedsper100k: beds,
                tests: tests
              };

              if(geom) {
                  var feature = {
                  type: "Feature",
                  geometry: geom.geometry,
                  properties: props,
                };

                //add to source
                thisRef.source.data.features.push(feature);
              }
           }

         }
        
      }

      //loop through each country and create the feature for the latest stats
      for (var i = 0; i < data.length; i++) {

        //hospital beds per 100k population
        var beds = data[i].population.hospital_beds_100k * 1;

        //testing
        var tests = 0
        if(data[i].tests.length > 0) {
          tests = data[i].tests[data[i].tests.length -1]["Cumulative total"]*1 
        }

        //get the geometry from the country bounds
        var geom = thisRef.allCountryBounds.find(cb => cb.properties.name === data[i].Country_WHO)

         //first calculate the latest stats
          var lastConfirmed =
            data[i].cases[data[i].cases.length - 1].cumulative_cases;
          var lastRecovered =
            data[i].cases[data[i].cases.length - 1].cumulative_recovered;
          var lastDeaths =
            data[i].cases[data[i].cases.length - 1].cumulative_deaths;
          var lastActive = lastConfirmed - lastRecovered - lastDeaths;
          var lastUpdated = data[i].cases[data[i].cases.length - 1].date;

          //confirmed per 100k population
          var confirmedrate = lastConfirmed / data[i].population.population;
          var confirmedper100k = confirmedrate * 100000;
          confirmedper100k = parseFloat(confirmedper100k.toFixed(0));

          //confirmed per 100k population
          var deathsrate = lastDeaths / data[i].population.population;
          var rdeathsper100k = deathsrate * 100000;
          var deathsper100k = parseFloat(rdeathsper100k.toFixed(0));

          if (deathsper100k === 0) {
            deathsper100k = parseFloat(rdeathsper100k.toFixed(2));
          }

          

          //create the feature
          var coords = [data[i].lng, data[i].lat];
          var props = {
            country: data[i].Country_WHO,
            confirmed: lastConfirmed,
            recovered: lastRecovered,
            deaths: lastDeaths,
            active: lastActive,
            date: lastUpdated,
            confirmedper100k: confirmedper100k,
            deathsper100k: deathsper100k,
            bedsper100k: beds,
            tests: tests
          };

          if(geom) {
              var feature = {
              type: "Feature",
              geometry: geom.geometry,
              properties: props,
            };

            //add to source
            thisRef.source.data.features.push(feature);
          }
        
      }

      //sort by count desc
      thisRef.source.data.features = thisRef.source.data.features.sort(
        function (a, b) {
          a = a.properties.confirmed;
          b = b.properties.confirmed;
          return a > b ? -1 : a < b ? 1 : 0;
        }
      );

      //set the source data
      if (thisRef.map.getSource("covid-africa-cases")) {
        thisRef.map
          .getSource("covid-africa-cases")
          .setData(thisRef.source.data);

        //zoom to the country
        var coords = [24, -3];
        var zoom = 1.8;
        var pitch = 0;

        if (countryDisplay && countryDisplay !== "") {
          coords = [data[0].lng, data[0].lat];
          zoom = 4;
          pitch = 60;
        }

        thisRef.map.flyTo({
          center: coords,
          zoom: zoom,
          pitch: pitch,
          essential: true,
        });
      }
    },
    loadHospitalData(data) {
      var thisRef = this;

      //clear the data
      thisRef.hospitalsource.data.features = [];
      var feats = []

      //loop through each country and create the feature
      for (var i = 0; i < data.length; i++) {
        //create the feature
        var coords = [data[i].Long*1, data[i].Lat*1];
        var props = data[i];

        var feature = {
          type: "Feature",
          geometry: {
            type: "Point",
            coordinates: coords,
          },
          properties: props,
        };

        //add to source
        feats.push(feature);
      }

      thisRef.hospitalsource.data.features = feats
      thisRef.map.getSource("hospitals").setData(thisRef.hospitalsource.data);
    },
    loadMap() {
      let thisRef = this;
      mapboxgl.accessToken =
        "pk.eyJ1Ijoic2hhemlhdiIsImEiOiJjamt1eDl1MG0wam9wM2txbmc5em52dzVzIn0.5GURhst0HPYdFs8BlVHH1Q";
      var map = this.map;

      map = new mapboxgl.Map({
        container: "map", // container id
        //style: 'mapbox://styles/mapbox/streets-v11', // stylesheet location
        style:
          "https://api.maptiler.com/maps/1314eca6-6818-4d57-af25-e8e5eab2e73b/style.json?key=m9rARlck6j9xxXkBz21x",
        center: [24, 0], // starting position [lng, lat]
        zoom: 1.8, // starting zoom
      });
      this.map = map;

      map.addControl(new mapboxgl.NavigationControl());
      map.addControl(new mapboxgl.FullscreenControl());
      map.addControl(
        new mapboxgl.GeolocateControl({
          positionOptions: {
            enableHighAccuracy: true,
          },
          trackUserLocation: true,
        })
      );

      map.on("load", function () {
        //load the bounds data once
        thisRef
          .loadCountryBounds()
          .then((countrybounds) => {
            //store the data
            thisRef.allCountryBounds = countrybounds;

            //then continure loading the data
            thisRef.mapLoaded = true;
            thisRef.addSources();
            thisRef.addLayers();
            thisRef.loadData(thisRef.allData, thisRef.countryDisplay);
          })
          .catch((err) => {
            console.error(err);
          });

        //load the hospitals
        thisRef
          .loadHospitals()
          .then((hospitals) => {

            //store all the data
            thisRef.allHospitalsData = hospitals

            thisRef.createHospitalLayer()
            thisRef.loadHospitalData(hospitals)

          })
          .catch((err) => {
            console.error(err);
          });
      });
    },
    resize: function () {
      var thisRef = this;
      setTimeout(function () {
        thisRef.map.resize();
      }, 500);
    },
    addSources() {
      let thisRef = this;
      let map = this.map;

      thisRef.source = {
        type: "geojson",
        data: {
          type: "FeatureCollection",
          features: [],
        },
      };
      map.addSource("covid-africa-cases", thisRef.source);
    },
    addLayers() {

      // poly layers
      this.createPolyLayer();

    },
    createPolyLayer() {
      let map = this.map;
      let thisRef = this;

      // default and starting layer is confirmed cases
      var layer = this.activeLayer;
      var currDate = this.currentDate;

      map.addLayer({
        id: "cases-poly",
        type: "fill-extrusion",
        source: "covid-africa-cases",
        layout: {
          visibility: "visible",
        },
        paint: {
          "fill-extrusion-color": [
            "interpolate",
            ["linear"],
            ["get", layer],
            1000,
            "#00b8f8",
            10000,
            "#0093ee",
            50000,
            "#006ddb",
            100000,
            "#0046bd",
            500000,
            "#001492",
          ],
          // Get fill-extrusion-height from the source 'height' property.
          "fill-extrusion-height": [
            "interpolate",
            ["linear"],
            ["get", "confirmed"],
            1000,
            10000,
            50000,
            100000,
          ],
          // Make extrusions slightly opaque for see through indoor walls.
          "fill-extrusion-opacity": {
            stops: [
              [1, 0.35],
              [4, 0.55],
              [7, 0.75],
            ],
          },
        },
        //filter: [">", ["get", layer], 0],
        "filter": ['all',
            ['>', ['get', layer], 0],
            ['==', ['get', 'date'], currDate]
          ]
      });

      map.addLayer({
        id: "cases-count",
        type: "symbol",
        source: "covid-africa-cases",
        layout: {
          "text-field": ["get", layer],
          "text-font": ["DIN Offc Pro Medium", "Arial Unicode MS Bold"],
          "text-size": 10,
          "text-allow-overlap": false,
          visibility: "visible",
        },
        paint: {
          "text-color": "#fff",
        },
        "filter": ["all",
            ['==', ["get", 'date'], currDate]
          ]
      });

      map.addLayer({
        id: "cases-line",
        type: "line",
        source: "covid-africa-cases",
        layout: {},
        paint: {
          "line-color": "#64B5F6",
          "line-width": 1,
          "line-opacity": {
            stops: [
              [1, 0.5],
              [4, 0.3],
              [7, 0.1],
            ],
          },
        },
        //filter: [">", ["get", layer], 0],
        "filter": ["all",
            [">", ["get", layer], 0],
            ['==', ["get", 'date'], currDate]
          ]
      });

      var popup = new mapboxgl.Popup({
        closeButton: false,
        className: "popup-class",
      });

      map.on("mousemove", "cases-poly", function (e) {

        if(e.originalEvent.cancelBubble){
          return;
        }

        map.getCanvas().style.cursor = "pointer";
        popup.remove();

        // var coordinates = e.features[0].geometry.coordinates.slice();
        var content = thisRef.getPopUpHTML(e.features[0]);

        if (e.features.length > 0) {
          // Populate the popup and set its coordinates
          // based on the feature found.
          popup.setLngLat(e.lngLat).setHTML(content).addTo(map);
        } else {
          map.getCanvas().style.cursor = "";
          popup.remove();
        }
      });

      map.on("mouseleave", "cases-poly", function () {
        map.getCanvas().style.cursor = "";
        popup.remove();
      });
    },
    createHospitalLayer() {
      let map = this.map;
      let thisRef = this;
         
      //hospitals
      thisRef.hospitalsource = {
        type: "geojson",
        data: {
          type: "FeatureCollection",
          features: [],
        },
        cluster: true,
        clusterMaxZoom: 10, // Max zoom to cluster points on
        clusterRadius: 25
      };
      map.addSource("hospitals", thisRef.hospitalsource);

      map.addLayer({
        id: "hospitals-layer",
        type: "circle",
        source: "hospitals",
         layout: {
          visibility: "none",
        },
        paint: {
          'circle-color': '#ab5ecc',
          // 'circle-radius': {
          //   'stops': [
          //     [1, 1],
          //     [22, 10]
          //   ]
          // },
          // "circle-opacity": {
          // 'stops': [
          //     [1, 0.3],
          //     [18, 1]
          //   ]
          // },
          'circle-radius': [
            'step',
            ['get', 'point_count'],
            10,
            500,
            15,
            1000,
            20
          ],
          'circle-stroke-width': 0
        }
      });

      map.addLayer({
        id: 'hospitals-cluster-count',
        type: 'symbol',
        source: 'hospitals',
        filter: ['has', 'point_count'],
        layout: {
        'text-field': '{point_count_abbreviated}',
        'text-font': ['DIN Offc Pro Medium', 'Arial Unicode MS Bold'],
        'text-size': 10,
        "text-allow-overlap": true,
        "visibility": "none"
        },
        paint: {
          "text-color": "#fff",
        }
      });

      //interactions
      var popup = new mapboxgl.Popup({
        closeButton: false,
        className: "popup-class",
      });

      map.on("mousemove", "hospitals-layer", function (e) {
        map.getCanvas().style.cursor = "pointer";
        popup.remove();

        // var coordinates = e.features[0].geometry.coordinates.slice();

        //check for popup
        if(e.features[0].properties["Facility name"]) {
          var content = thisRef.getHospitalPopUpHTML(e.features[0]);

          if (e.features.length > 0) {
            // Populate the popup and set its coordinates
            // based on the feature found.
            popup.setLngLat(e.lngLat).setHTML(content).addTo(map);
          } else {
            map.getCanvas().style.cursor = "";
            popup.remove();
          }

          e.originalEvent.cancelBubble = true;
          e.originalEvent.preventDefault()
          e.originalEvent.stopPropagation()
        }

      });

      map.on("mouseleave", "hospitals-layer", function () {
        map.getCanvas().style.cursor = "";
        popup.remove();
      });

    },
    getPopUpHTML(data) {
      let html = "";

      html =
        "<span style='color: #7b1fa2!important; font-size: 16px;font-weight: 400;'>" +
        data.properties.country +
        "</span><hr />";

      html +=
        "<span>Confirmed : " +
        data.properties.confirmed.toLocaleString("en").replace(/\,/g, " ") +
        "</span><br/>";
      html +=
        "<span>Recovered : " +
        data.properties.recovered.toLocaleString("en").replace(/\,/g, " ") +
        "</span><br/>";
      html +=
        "<span>Deaths : " +
        data.properties.deaths.toLocaleString("en").replace(/\,/g, " ") +
        "</span><br/>";
      html +=
        "<span>Active : " +
        data.properties.active.toLocaleString("en").replace(/\,/g, " ") +
        "</span><br/>";

      return html;
    },
    getHospitalPopUpHTML(data) {
      let html = "";

      html =
        "<span style='color: #7b1fa2!important; font-size: 16px;font-weight: 400;'>" +
        data.properties["Facility name"] +
        "</span><hr />";

        html +=
        "<span>Country : " +
        data.properties["Country"] +
        "</span><br/>";

      return html;
    },
    changeLayer(layer) {
      this.activeLayer = layer;
      var map = this.map;

      // set fill-extrusion-color and fill-extrusion-height for confirmed, recovered, deaths, active etc.
      if (layer === "confirmed") {
        //
        map.setPaintProperty("cases-poly", "fill-extrusion-color", [
          "interpolate",
          ["linear"],
          ["get", layer],
          1000,
          "#00b8f8",
          10000,
          "#0093ee",
          50000,
          "#006ddb",
          100000,
          "#0046bd",
          500000,
          "#001492",
        ]);
        //
        map.setPaintProperty("cases-poly", "fill-extrusion-height", [
          "interpolate",
          ["linear"],
          ["get", layer],
          1000,
          10000,
          50000,
          100000,
        ]);

        map.setPaintProperty("cases-line", "line-color", "#64B5F6");
      } else if (layer === "recovered") {
        //
        map.setPaintProperty("cases-poly", "fill-extrusion-color", [
          "interpolate",
          ["linear"],
          ["get", layer],
          1000,
          "#78d23d",
          10000,
          "#58bb43",
          50000,
          "#3aa346",
          100000,
          "#1e8c45",
          500000,
          "#007542",
        ]);
        //
        map.setPaintProperty("cases-poly", "fill-extrusion-height", [
          "interpolate",
          ["linear"],
          ["get", layer],
          1000,
          10000,
          50000,
          100000,
        ]);

        map.setPaintProperty("cases-line", "line-color", "#4CAF50");
      } else if (layer === "deaths") {
        //
        map.setPaintProperty("cases-poly", "fill-extrusion-color", [
          "interpolate",
          ["linear"],
          ["get", layer],
          100,
          "#f48fb1",
          1000,
          "#f06292",
          5000,
          "#ec407a",
          10000,
          "#e91e63",
          50000,
          "#c2185B",
        ]);
        //
        map.setPaintProperty("cases-poly", "fill-extrusion-height", [
          "interpolate",
          ["linear"],
          ["get", layer],
          100,
          1000,
          5000,
          10000,
        ]);
        //
        map.setPaintProperty("cases-line", "line-color", "#ec407a");
      } else if (layer === "active") {
        //
        map.setPaintProperty("cases-poly", "fill-extrusion-color", [
          "interpolate",
          ["linear"],
          ["get", layer],
          1000,
          "#ffa12c",
          10000,
          "#ff872c",
          50000,
          "#fe612c",
          100000,
          "#fd3a2d",
          500000,
          "#f11d28",
        ]);
        //
        map.setPaintProperty("cases-poly", "fill-extrusion-height", [
          "interpolate",
          ["linear"],
          ["get", layer],
          1000,
          10000,
          50000,
          100000,
        ]);
        //
        map.setPaintProperty("cases-line", "line-color", "#ffa726");
      } else if (layer === "confirmedper100k") {
        //
        map.setPaintProperty("cases-poly", "fill-extrusion-color", [
          "interpolate",
          ["linear"],
          ["get", layer],
          10,
          "#00b8f8",
          100,
          "#0093ee",
          500,
          "#006ddb",
          1000,
          "#0046bd",
          5000,
          "#001492",
        ]);
        //
        map.setPaintProperty("cases-poly", "fill-extrusion-height", [
          "interpolate",
          ["linear"],
          ["get", layer],
          10,
          100,
          500,
          1000,
        ]);
        //
        map.setPaintProperty("cases-line", "line-color", "#64B5F6");
      } else if (layer === "deathsper100k") {
        //
        map.setPaintProperty("cases-poly", "fill-extrusion-color", [
          "interpolate",
          ["linear"],
          ["get", layer],
          10,
          "#f48fb1",
          25,
          "#f06292",
          50,
          "#ec407a",
          75,
          "#e91e63",
          100,
          "#c2185B",
        ]);
        //
        map.setPaintProperty("cases-poly", "fill-extrusion-height", [
          "interpolate",
          ["linear"],
          ["get", layer],
          10,
          25,
          50,
          100,
        ]);
        //
        map.setPaintProperty("cases-line", "line-color", "#ec407a");
      } else if (layer === "bedsper100k") {
        //
        map.setPaintProperty("cases-poly", "fill-extrusion-color", [
          "interpolate",
          ["linear"],
          ["get", layer],
          10,
          "#b18ff4",
          25,
          "#8854f0",
          50,
          "#783cf0",
          75,
          "#6b27f2",
          100,
          "#5500ff",
        ]);
        //
        map.setPaintProperty("cases-poly", "fill-extrusion-height", [
          "interpolate",
          ["linear"],
          ["get", layer],
          10,
          25,
          50,
          100,
        ]);
        //
        map.setPaintProperty("cases-line", "line-color", "#b18ff4");
      }
      else if (layer === "tests") {
        //
        map.setPaintProperty("cases-poly", "fill-extrusion-color", [
          "interpolate",
          ["linear"],
          ["get", layer],
          10000,
          "#00b8f8",
          100000,
          "#0093ee",
          500000,
          "#006ddb",
          1000000,
          "#0046bd",
          5000000,
          "#001492",
        ]);
        //
        map.setPaintProperty("cases-poly", "fill-extrusion-height", [
          "interpolate",
          ["linear"],
          ["get", layer],
          1000,
          10000,
          50000,
          100000,
        ]);

        map.setPaintProperty("cases-line", "line-color", "#64B5F6");
      }

      //hospitals layer
      if (layer === "facilities") {
        //visible
        this.map.setLayoutProperty(
          "hospitals-layer",
          "visibility",
          "visible"
        );

        this.map.setLayoutProperty(
          "hospitals-cluster-count",
          "visibility",
          "visible"
        );

        this.map.setLayoutProperty(
          "cases-poly",
          "visibility",
          "none"
        );

        this.map.setLayoutProperty(
          "cases-count",
          "visibility",
          "none"
        );
      }
      else {
        //visible
        this.map.setLayoutProperty(
          "cases-poly",
          "visibility",
          "visible"
        );

        this.map.setLayoutProperty(
          "cases-count",
          "visibility",
          "visible"
        );

        this.map.setLayoutProperty(
          "hospitals-layer",
          "visibility",
          "none"
        );

        this.map.setLayoutProperty(
          "hospitals-cluster-count",
          "visibility",
          "none"
        );

        // cases count label
        map.setLayoutProperty("cases-count", "text-field", ["get", layer]);
      }

      //hide the time slider for some layers
      if(layer === "tests" || layer === "bedsper100k" || layer === "facilities") {
        this.showPlayback = false
      }
      else {
        this.showPlayback = true
      }
    
      // // filter to not show poly if 0 cases
      // var filter =  ['>', ['get', layer], 0]
      // map.setFilter('cases-poly', filter)

      //post the GA
      gtag("event", "map", {
        event_category: layer,
        send_to: "UA-161523063-2",
      });
    },
    // changeLayerOld(layer) {
    //   // REPLACED THIS WITH ABOVE
    //   this.activeLayer = layer;

    //   //hide and show the layers
    //   if (layer === "Confirmed") {
    //     this.map.setLayoutProperty(
    //       "confirmed-cluster",
    //       "visibility",
    //       "visible"
    //     );
    //     this.map.setLayoutProperty(
    //       "confirmed-cluster-count",
    //       "visibility",
    //       "visible"
    //     );

    //     this.map.setLayoutProperty("recovered-cluster", "visibility", "none");
    //     this.map.setLayoutProperty(
    //       "recovered-cluster-count",
    //       "visibility",
    //       "none"
    //     );

    //     this.map.setLayoutProperty("deaths-cluster", "visibility", "none");
    //     this.map.setLayoutProperty(
    //       "deaths-cluster-count",
    //       "visibility",
    //       "none"
    //     );

    //     this.map.setLayoutProperty("active-cluster", "visibility", "none");
    //     this.map.setLayoutProperty(
    //       "active-cluster-count",
    //       "visibility",
    //       "none"
    //     );
    //   } else if (layer === "Recovered") {
    //     this.map.setLayoutProperty("confirmed-cluster", "visibility", "none");
    //     this.map.setLayoutProperty(
    //       "confirmed-cluster-count",
    //       "visibility",
    //       "none"
    //     );

    //     this.map.setLayoutProperty(
    //       "recovered-cluster",
    //       "visibility",
    //       "visible"
    //     );
    //     this.map.setLayoutProperty(
    //       "recovered-cluster-count",
    //       "visibility",
    //       "visible"
    //     );

    //     this.map.setLayoutProperty("deaths-cluster", "visibility", "none");
    //     this.map.setLayoutProperty(
    //       "deaths-cluster-count",
    //       "visibility",
    //       "none"
    //     );

    //     this.map.setLayoutProperty("active-cluster", "visibility", "none");
    //     this.map.setLayoutProperty(
    //       "active-cluster-count",
    //       "visibility",
    //       "none"
    //     );
    //   } else if (layer === "Deaths") {
    //     this.map.setLayoutProperty("confirmed-cluster", "visibility", "none");
    //     this.map.setLayoutProperty(
    //       "confirmed-cluster-count",
    //       "visibility",
    //       "none"
    //     );

    //     this.map.setLayoutProperty("recovered-cluster", "visibility", "none");
    //     this.map.setLayoutProperty(
    //       "recovered-cluster-count",
    //       "visibility",
    //       "none"
    //     );

    //     this.map.setLayoutProperty("deaths-cluster", "visibility", "visible");
    //     this.map.setLayoutProperty(
    //       "deaths-cluster-count",
    //       "visibility",
    //       "visible"
    //     );

    //     this.map.setLayoutProperty("active-cluster", "visibility", "none");
    //     this.map.setLayoutProperty(
    //       "active-cluster-count",
    //       "visibility",
    //       "none"
    //     );
    //   } else if (layer === "Active") {
    //     this.map.setLayoutProperty("confirmed-cluster", "visibility", "none");
    //     this.map.setLayoutProperty(
    //       "confirmed-cluster-count",
    //       "visibility",
    //       "none"
    //     );

    //     this.map.setLayoutProperty("recovered-cluster", "visibility", "none");
    //     this.map.setLayoutProperty(
    //       "recovered-cluster-count",
    //       "visibility",
    //       "none"
    //     );

    //     this.map.setLayoutProperty("deaths-cluster", "visibility", "none");
    //     this.map.setLayoutProperty(
    //       "deaths-cluster-count",
    //       "visibility",
    //       "none"
    //     );

    //     this.map.setLayoutProperty("active-cluster", "visibility", "visible");
    //     this.map.setLayoutProperty(
    //       "active-cluster-count",
    //       "visibility",
    //       "visible"
    //     );
    //   }

    //   //post the GA
    //   gtag("event", "map", {
    //     event_category: layer,
    //     send_to: "UA-161523063-2",
    //   });
    // },
    loadCountryBounds() {
      var self = this;

      return new Promise((resolve, reject) => {
        //get the data
        fetch("../../data/geo/africa.geojson")
          .then((response) => {
            return response.json();
          })
          .then((data) => {
            resolve(data.features);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    loadHospitals() {
      var self = this;

      return new Promise((resolve, reject) => {
        var d = new Date();
        var url = "data/africa/facilities.csv";

        if(self.$vuetify.breakpoint.lgAndUp) {
          //desktop
          Papa.parse(url, {
            download: true,
            header: true,
            skipEmptyLines: true,
            complete: function (results) {
              resolve(results.data);
            },
            error: function (err) {
              reject(err);
            },
          });
        }
        else {
          resolve([]);
        }
        
      });
    },
    getHospitalsByCountry(country) {
      return this.allHospitalsData.filter(h => h.Country === country)
    },
    togglePlay() {
      var self = this

      //check if playing or not
      if(this.isPlaying) {
        clearInterval(this.timer)
      }
      else {
        this.timer = setInterval(function(){

          //increment the time slider
          if(self.tickValue === self.ticksLabels.length - 1) {
            //is at the end so loop to beginning
            self.tickValue = 0
          }
          else {
            self.tickValue += 1
          }

        }, 750)
      }

      this.isPlaying = !this.isPlaying
    }
  },
};
</script>

<style scoped>
.mapbox-map {
  width: 100%;
  height: 100%;
  background: #45516e;
  border-radius: 4px;
}
</style>

<style>
.mapboxgl-popup {
  margin-top: -15px;
}

.popup-class {
  color: black;
  opacity: 0.85;
}
</style>